export interface SearchSuggestion {
  query: string
  popularity?: number
}

export interface SearchResult {
  id: string // NOT objectID — domain owns the language
  title: string
  url: string
  description?: string
  imageUrl?: string
  contentType?: string
}

export interface SearchResponse {
  suggestions: SearchSuggestion[]
  results: SearchResult[]
}

/** Detail carried on the search-select CustomEvent */
export interface SearchSelectDetail {
  type: 'suggestion' | 'result'
  /** Populated when type === 'suggestion' */
  query?: string
  /** Populated when type === 'result' */
  result?: SearchResult
}

/**
 * Build the fallback search navigation URL.
 * @example buildSearchUrl('/search', 'grace alone') → '/search?query=grace%20alone'
 */
export function buildSearchUrl(baseUrl: string, query: string): string {
  return `${baseUrl}?query=${encodeURIComponent(query)}`
}
